import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { WorkingHoursSpecification } from '../../constants';
export var generateCpuItems = function generateCpuItems(items) {
  return items.map(function (item) {
    return {
      value: String(item),
      label: "".concat(item, " \u0428\u0442")
    };
  });
};
export var generateRamItems = function generateRamItems(items) {
  return items.map(function (item) {
    return {
      value: String(item),
      label: "".concat(item, " \u0413\u0411")
    };
  });
};
export function generateInstanceConfigItems(items, valuesPostfixes) {
  var _ref = valuesPostfixes !== null && valuesPostfixes !== void 0 ? valuesPostfixes : [],
    _ref$ = _ref[0],
    fisrtPostfix = _ref$ === void 0 ? 'vCPU' : _ref$,
    _ref$2 = _ref[1],
    secondPostfix = _ref$2 === void 0 ? 'ГБ RAM' : _ref$2;
  return items.map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      cpu = _ref3[0],
      ram = _ref3[1];
    return {
      value: [cpu, ram].join(' '),
      label: "".concat(cpu).concat(fisrtPostfix, ", ").concat(ram).concat(secondPostfix)
    };
  });
}
export function generateBaseItems(arr, labelReplacerFn) {
  return arr.map(function (item) {
    return {
      value: String(item),
      label: labelReplacerFn ? labelReplacerFn(String(item)) : String(item)
    };
  });
}
export * from './disk';
export * from './eip';
export * from './obs';
export var getNumeralWord = function getNumeralWord(value, words) {
  var newValue = Math.abs(value) % 100;
  var num = value % 10;
  if (newValue > 10 && newValue < 20) return words[2];
  if (num > 1 && num < 5) return words[1];
  if (num === 1) return words[0];
  return words[2];
};
export var getMaxWorkingHoursAmount = function getMaxWorkingHoursAmount(period, maxHours) {
  switch (period) {
    case WorkingHoursSpecification.Hour:
      return maxHours.hour;
    case WorkingHoursSpecification.Day:
      return maxHours.day;
    case WorkingHoursSpecification.Month:
      return maxHours.month;
    default:
      return 1;
  }
};